import React from 'react'
import { convertToReadableDate } from 'Root/helpers'

import Section from 'Components/Section'
import GridRow from 'Components/Grid/GridRow'
import Report from 'Components/Report'

const ArchiveRow = ({ row: archive }) => (
  <>
    <GridRow>
      <div>{archive.patientRef}</div>
      <div>{archive.patientInitials}</div>
      <div>{archive.tcode}</div>
      <div>
        {archive.deletedDate ? convertToReadableDate(archive.deletedDate) : ''}
      </div>
      {Object.keys(archive.archivedReasons).map(item => {
        return <div>{archive.archivedReasons[item]}</div>
      })}
    </GridRow>
  </>
)

const TotalArchiveBreakdownRow = ({ row: archive }) => (
  <>
    <GridRow noBackground>
      <div>Total</div>
      {Object.keys(archive.archivedReasons).map(item => {
        return <div>{archive.archivedReasons[item]}</div>
      })}
    </GridRow>
  </>
)

const columns = [
  { header: 'Patient Ref.', property: 'patientRef' },
  { header: 'Patient Initial', property: 'patientInitials' },
  { header: 'T-Code', property: 'tcode' },
  { header: 'Archived Date', property: 'deletedDate' }
]

const totalBreakdownColumns = [{ header: 'Total', property: '', size: '4x' }]

export default ({
  archiveItems,
  initials,
  columnReasons,
  archiveItemsBreakdown
}) => {
  return (
    <>
      <Section header="Provider" title={initials} />
      <Report
        id="archive"
        report={{ archiveReport: archiveItems }}
        columns={[...columns, ...columnReasons]}
        ReportRow={ArchiveRow}
        defaultSortIndex={0}
        disableSort={true}
        prop="archiveReport"
      />
      <Report
        id="totalArchivedByDoctor"
        report={{
          totalArchivedByDoctorReport: [
            { archivedReasons: archiveItemsBreakdown }
          ]
        }}
        columns={[...totalBreakdownColumns, ...columnReasons]}
        ReportRow={TotalArchiveBreakdownRow}
        defaultSortIndex={0}
        disableSort={true}
        prop="totalArchivedByDoctorReport"
      />
    </>
  )
}
